var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcTestOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-test-off_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-test-off_svg__b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  fill: "#F3F4F8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DADEE5",
  d: "M24 8.802h-8.54c-.35-.59-.84-1.09-1.44-1.44-.33-.2-.63-1.36-.63-1.36-.9-.27-1.88-.27-2.79 0 0 0-.28 1.16-.61 1.36A3.97 3.97 0 0 0 8 10.802c0 .17.03.33.05.5-.02.17-.05.33-.05.5 0 1.86 1.28 3.41 3 3.86v9.14c0 1.66 1.34 3 3 3h10c1.66 0 3-1.34 3-3v-13c0-1.66-1.34-3-3-3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19 19.802h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1M19 15.802h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1M19 23.802h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1M15 19.802a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15 23.802a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B6BAC0",
  d: "M17 10.802c0 2.76-2.24 5-5 5s-5-2.24-5-5a5 5 0 0 1 3.6-4.8l.68 1.37c.3.59 1.14.59 1.44 0l.68-1.37a5 5 0 0 1 3.6 4.8m-5.4.93a1.006 1.006 0 0 0 .79-1.85l-2.32-.98a.76.76 0 0 0-.92.27c-.24.34-.15.81.2 1.05l2.08 1.42c.05.04.11.07.18.1z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-test-off_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h34v34H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-test-off_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h34v34H0z"
})))));
export default SvgIcTestOff;